class Address {
  constructor(addressStreet, address2code, countryName) {
    this.address = {
      country: countryName,
      addressStreet,
      address2code
    };
  }

  getData() {
    return this.address;
  }
}

export default Address;
